import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { PageSection } from '../PageSection';
import { EmphasisLines } from '../EmphasisLines';
import { lastQuestion } from '../../data/salesContent';
export function LastQuestionSection() {
  return <PageSection labelledBy="last-question-title" data-id="element-125" data-mp="b9rutayomnpj">
      <SectionHeading id="last-question-title" title="Una última pregunta" data-id="element-126" data-mp="69dl7ohfn5pe" />
      <div className="mx-auto mt-6 max-w-xl space-y-1 text-center text-base italic leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-127" data-mp="26qopa9tgwlv">
        {lastQuestion.moments.map(m => <p key={m} data-id="element-128" data-mp="3tkdagy28uu3h">{m}</p>)}
      </div>
      <p className="mx-auto mt-6 max-w-xl text-center font-display text-xl font-extrabold uppercase leading-snug text-cyan-400 md:text-2xl" data-id="element-129" data-mp="3ombp26hciiou">
        {lastQuestion.question}
      </p>
      <div className="mx-auto mt-5 max-w-xl space-y-1 text-center text-base leading-relaxed text-zinc-300 md:text-[17px]" data-id="element-130" data-mp="3jlns746fr7mp">
        {lastQuestion.paragraphs.map(p => <p key={p} data-id="element-131" data-mp="3ao3l3elw6h46">{p}</p>)}
      </div>
      <EmphasisLines lines={lastQuestion.closing} className="mt-8" data-id="element-132" data-mp="3ap6dxs2rytmq" />
    </PageSection>;
}